import React from 'react';
import { Alert } from 'antd';
import { CaseParty } from '../../../../services/case';
import PartyForm from './PartyForm';

interface OurPartyStepProps {
  data: CaseParty[];
  onChange: (data: CaseParty[]) => void;
}

const OurPartyStep: React.FC<OurPartyStepProps> = ({ data, onChange }) => {
  return (
    <div>
      <Alert
        message="我方信息"
        description="请添加至少一个我方当事人信息。我方是指委托我们代理的一方。"
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />
      <PartyForm
        parties={data}
        onChange={onChange}
        partyType="our_side"
        minParties={1}
      />
    </div>
  );
};

export default OurPartyStep;
